module.exports = __webpack_public_path__ + "static/media/tshirt-sm.9e5f52ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dashboard/tshirt-sm.png
// module id = 2061
// module chunks = 108